export default __webpack_public_path__ + "static/media/diabetes-management.59a418c4.svg";